import { Box, CircularProgress, Typography } from '@mui/material'
import { alpha } from '@mui/material/styles'
import React from 'react'

interface FullScreenLoadingProps {
  message?: string
}

export const FullScreenLoading: React.FC<FullScreenLoadingProps> = ({
  message,
}) => {
  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        width: '100vw',
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: theme.zIndex.modal,
        backgroundColor: alpha(theme.palette.background.paper, 0.9),
      })}
    >
      <CircularProgress size={60} />
      <Typography variant="h6" sx={{ mt: 2 }}>
        {message}
      </Typography>
    </Box>
  )
}
